// extracted by mini-css-extract-plugin
export default {"contenedor":"HorarioRangos_contenedor__F0yjZ","acciones":"HorarioRangos_acciones__A5eZ7","grilla":"HorarioRangos_grilla__8SB7R"};